import { IonList, IonLabel, IonRow, IonCol, IonGrid, IonCardContent, IonIcon, IonItemDivider } from "@ionic/react";
import { BookLoad } from "../../../models/home/BookLoad.model";
import { GetShipment } from "../../../models/home/GetShipment.model";
import { Currency } from "../../../schemas/BookLoad/BookLoad.schema";
import { IONICWrapper, LPEFeedbackWrapper } from "../../../utils/common";
import { getSessionId, logEvent, setScreenName } from "../../../utils/Analytics";
import {
  BOOKLOAD_CANCELLED,
  BOOKLOAD_ONHOLD,
  BOOKLOAD_STATUS_OK,
  BOOKLOAD_STATUS_REJECTED,
  BOOKLOAD_TIMEOUT,
  NO_NETWORK,
  OFFLINE_MODE_STATE,
  PLEASE_CHECK_NETWORK_CONNECTIVITY_MESSAGE,
  MODULES,
  CARRIER_ASSIGNED_MODULE_WEB,
  NO_NEXT_ROUTE,
  NEED_NEXT_ROUTE,
  RECOMMENDED_TAB,
  WATCHED_TAB,
  Navigate_Module,
  Roles,
  APPOINTMENT_MODAL_MESSAGE,
  APPOINTMENT_MODAL_TITLE,
  APPOINTMENT_INDICATOR_STATE_VALUE,
  APPOINTMENT_MODAL_BUTTON_NAME,
  SAME_DAY_PICKUP_POPUP_TITLE,
  SAME_DAY_PICKUP_POPUP_MESSAGE,
  APPOINTMENT_MODAL_TYPE,
  SAME_DAY_PICKUP_MODAL_TYPE,
  GENERIC_PRE_BOOK_NOW_POPUP_MESSAGE,
  GENERIC_PRE_BOOK_NOW_POPUP_TITLE,
  CONTACT_DETAILS_NOT_FOUND,
  DRIVER_GAP_FILL_IN_ACTIONS
} from "../../../utils/constants";
import { EVENT, SCREEN, TAB } from "../../../utils/constants.analytics";
import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { BookLoadConfirmModal } from "../common/BookLoadModal/BookLoadConfirmModal";
import { BookLoadModal } from "../common/BookLoadModal/BookLoadModal";
import { LoadTile } from "../load-tile";
import "./LoadsList.scss";
import "../../../../app/components/app/home/Load-Similar.scss"
import { ICarrierContactInfo } from "../../../schemas/App/App.Schema";
import i18n from "../../../../i18n";
import { publishCarrierIntentMessage, clearSuccessorShipmentResponse, getPredecessorShipment } from "../../../actions/carrierAssign/action";
import { CarrierIntentMessageProps } from "../../../schemas/carrierAssign/CarrierAssign.schema";
import {
  getReloadShipmentDetails,
  constructSearchParams,
  getDestinationCityState,
  constructSearchParamsAfterBookLoad
} from "../../../pages/Execute/CarrierAssigned/shipmentPage.util";
import { getOffSet } from "../../../selectors/Search/selector"
import LoadSimilarContainer from "../similar-loads-list/Load-Similar-Container";
import { getShipmentDetails } from "../../../selectors/Myload/selector";
import ContactUsModal from "../../../components/shared/ContactUsModal/ContactUsModal";
import GetQualifiedModal from "../../../components/shared/GetQualifiedModal/GetQualifiedModal";
import { getUserMasterData } from "../../../selectors/selector";
import { CustomModalWeb } from "../../pages/userProfile/CustomModalWeb";
import { getContactEventDetails } from "../../../../app/utils/ContactUsModal.util";
import { store } from "../../../../app/store";
import { IUserDetails } from "../../../schemas/user";
import { IEShipment, IEShipmentInvolvedParty, IEShipmentResponse } from "../../../schemas/getShipment/GetShipment.schema";
import { ConfirmDriverDialog } from "../assign-driver/ConfirmDriverDialog";
import { appointmentState, getAppointmentTime, sameDateFreightCheckValue } from "app/utils/formatData";
import getTime from "app/utils/getTimePeriod";
import { ShipmentDetails } from "../shipment-details/shipmentDetails";
import { LoadStop } from "../loadStops/loadStops";
import { Persona } from "../persona/persona";
import { getPredecessorShipmentPayload } from "app/pages/Execute/AssignDriverList/assignDriver.util";
import { getAssignShipmentDriverResponse } from "app/selectors/carrierAssign/selector";
import { ToastMessage } from "app/utils/ToastMessage";
import { isElevatedLeasedOwenerOprRole } from "app/utils/roleUtil/RoleUtil";
import { isEmptyObject } from "../../utils/BasicLogical.Util";
import { contactUsDetailsRequest } from "app/actions/myload/action";


const LoadsList: React.FC<any> = (props: any) => {
  const { push } = useHistory();
  const dispatch = useDispatch();
  const offSetValues = useSelector(getOffSet())

  let details = [];
  const { loads = [], module = "", className = "", userDetails = {}, searchByIdResult = [] } = props;
  const [showMapId, setShowMapId] = useState<any>("");
  const [selecetedTab, setSelectedTab] = useState<any>("");
  const [sourceSys, setSys] = useState<any>("");
  const [isBookLoadModal, setBookLoadModal] = useState<boolean>(false);
  const [selectedLoadId, setSelectedLoadId] = useState<any>("");
  const [contactUsModal, setContactUsModal] = useState<boolean>(false);
  const [getQualifiedModal, setGetQualifiedModal] = useState<boolean>(false);
  const [bookLoad, setBookLoad] = useState<boolean>(false);
  const [clickType, updateClickType] = useState<string>("");
  const [hasSuccessorModal, setSuccessorModal] = useState<boolean>(false)
  const [isSimilarLoad, setIsSimilarLoad] = useState<boolean>(false);
  const [similarLoads, setSimilarLoads] = useState<any>([]);
  const updateduserDetails : IUserDetails = useSelector(getUserMasterData());
  const [contactDetails, setContactDetails] = useState<any>(null);
  const shipmentDetails: IEShipmentResponse = useSelector(getShipmentDetails());
  const shipmentInvolvedParties: IEShipmentInvolvedParty[] = shipmentDetails?.shipments
                            && shipmentDetails?.shipments?.length > 0 
                            ? shipmentDetails?.shipments[0]?.shipmentInvolvedParties : [];
  const shipmentDetailsAfterBookLoad: any = shipmentDetails?.shipments
                            && shipmentDetails?.shipments?.length > 0 
                            ? shipmentDetails?.shipments[0] : [];
                            
  const [driverDetails, setDriverDetails] = useState<any>([]);
  const [predecessorShipment, setPredecessorShipment] = useState<any>(null);
  const [shipmentData, setShipmentData] = useState<any>();
  const [showDriverAssignment, setShowDriverAssignment] = useState<boolean>(false);
  const [confirmBookLoadHeader, setConfirmBookLoadHeader] = useState<string>("");
  const assignedDriverResponse: any = useSelector(getAssignShipmentDriverResponse());
  const [preBookNowModalOpen,setPreBookNowModalOpen] = useState<boolean>(false);
  const [preBookNowModalMessage,setPreBookNowModalMessage] = useState<string>("");
  const [preBookNowModalType,setPreBookNowModalType] = useState<string>("");
  const [loadForModal,setLoadForModal] = useState<any>([]);
  const storeData = store.getState();
  const session = storeData && storeData.App && storeData.App.session;
  const sessionId = getSessionId(session.uuid);
  let viewedLoads = useRef<any>([]);
  const driverGapFillInActions = IONICWrapper?.details?.keys?.configuration?.DRIVER_GAP_FILL_IN_ACTIONS || DRIVER_GAP_FILL_IN_ACTIONS ;
  const isOnScreen = (loadId:string, rank: string) => {
    if(lead() != TAB.MYLOAD){
      ((lead() != undefined) && (lead() == TAB.RECOMMENDED)) ? 
      loadId && !viewedLoads.current.find((load: any) => load.loadId === loadId) && viewedLoads.current.push({"loadId" : loadId, "rank" : rank})
      :
      loadId && !viewedLoads.current.includes(loadId) && viewedLoads.current.push({loadId})
    }
  }
  const calculateTime = (stop: any) => {
    let _newAptTime: string = getTime(
      stop.appointmentFrom || "",
      stop.appointmentTo || ""
    );
    _newAptTime = (_newAptTime || "")
      .split("AM")
      .join("am")
      .split("PM")
      .join("pm")
      .replace(/Z/g, "")
      .replace(/z/g, "");
    return _newAptTime;
  };
  const reloadPopupMessage = IONICWrapper.details.keys && IONICWrapper.details.keys.configuration.reloadPopupMessage || i18n.t('reloadPopupMessage');
  const lead = () => {
    if (module && module === MODULES.SEARCH_RESULTS) {
      return (props.tabFrom === TAB.FAVORITE ? TAB.FAVORITE :
                        (props.tabFrom === TAB.RECENT ? TAB.RECENT : TAB.SEARCHED));
    }
    if (module && module.indexOf(TAB.RECOMMENDED) !== -1) {
      return TAB.RECOMMENDED;
    }
    if (module && module.indexOf(TAB.WATCHED) !== -1) {
      return TAB.WATCHED;
    }
    if (module && module.indexOf(TAB.MANAGE_CAPACITY) !== -1) {
      return TAB.MANAGE_CAPACITY;
    }
    if(module && module.indexOf(TAB.MYLOAD) !== -1){
      return TAB.MYLOAD;
    }
  };

  useEffect( () => () => {
    if(lead() != TAB.MYLOAD){
      if(lead() == TAB.RECOMMENDED || TAB.SEARCHED || TAB.MANAGE_CAPACITY){
        const eventName = lead() == TAB.RECOMMENDED ? EVENT.UE_RECOMMENDED_VIEW : EVENT.UE_SEARCH_VIEW;
        if(viewedLoads.current && viewedLoads.current.length > 0){
          LPEFeedbackWrapper.log(eventName, {
            screen: lead(),
            lead: lead(),
            loadId: viewedLoads.current,
            resultId: props.resultId
          });
        }
      }
    }
  }, [] );

  useEffect(() => {
    if (module && lead() === TAB.RECOMMENDED || lead() === TAB.WATCHED) {
      if (selecetedTab !== lead()) {
        setSelectedTab(lead());
        setShowMapId("");
      }
    };
  }, [module])

  useEffect(() => {
    setSuccessorModal(false);
  }, [])


  useEffect(() => {
    const status = assignedDriverResponse && assignedDriverResponse.assignDriverToShipment && assignedDriverResponse.assignDriverToShipment.status;
    if (status && props.successorShipment === null || !!(props.successorShipment && props.successorShipment.shipmentId === null)) {
      props.paginatedLoads(props.page)
      setSuccessorModal(true)
    }
  },[]);
  useEffect(() => {
   if(props?.bookLoadStatus?.status === BOOKLOAD_STATUS_OK && isElevatedLeasedOwenerOprRole()){
    confirmBookLoad()
   }
  }, [props.bookLoadStatus])

  const redirectToResults = () => {
    return module === MODULES.SEARCH_RESULTS ? push({
      pathname: `/app/${module}`,
      state: {
        showResults: true,
        searchInput: props.searchInput
      }
    }) : push({pathname:Navigate_Module.home,state:{subSegment:module.includes("homewatched") ? WATCHED_TAB : RECOMMENDED_TAB }});
  }

  useEffect(() => {
    if (shipmentDetails && shipmentDetails.shipments && shipmentDetails.shipments.length > 0) {
      /**
       * storing the current path and module before navigation to carrier assigned load details page.
       */
      if (bookLoad) {
        if (clickType === "viewMoreResults" && !module.includes(MODULES.MANAGE_CAPACITY_SEE_RESULTS)) {
          redirectToResults()
        }
        if (clickType === "assignDriver") {
          dispatch(clearSuccessorShipmentResponse());
          push(CARRIER_ASSIGNED_MODULE_WEB, {
            isBookLoad: true,
            shipments: shipmentDetails.shipments,
            module: props.module,
            shipmentId: selectedLoadId,
            isGlobalSearch: true,
            searchInput: constructSearchParamsAfterBookLoad(shipmentDetailsAfterBookLoad,offSetValues)
          });
        }
           removeLoadsFromStore(selectedLoadId || null);
      }
      setBookLoad(false);
    } else {
    }
  }, [bookLoad]);

  const buyLoad = () => {
    const loads = isSimilarLoad ? similarLoads : props.loads;
    const load = loads.filter(
      (item: any) => item.loadId === selectedLoadId
    );
    const modelLoad: BookLoad = new BookLoad();
    if (props.isNetworkAvailable || OFFLINE_MODE_STATE) {
      const data = {
        lhlCharges:
          (load[0] && load[0].rate && load[0].rate.lineHaulCharge.charge) || 0,
        fsrCharges:
          (load[0] && load[0].rate && load[0].rate.fuelCharge.charge) || 0,
        carrierId:(props.userDetails && props.userDetails.memberDetailsResponse &&
          props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.carrierId) || "",
        userId:(props.userDetails && props.userDetails.memberDetailsResponse &&
          props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.upn) || "",
        sourceSystem: (load[0] && load[0].sourceSystem) || "",
        loadId: load[0].loadId,
        amount: (load[0] && load[0].rate && load[0].rate.totalCharge) || 0,
        binRateId:
          (load[0] &&
            load[0].rate &&
            load[0].rate.binRateIdentifier &&
            load[0].rate.binRateIdentifier) ||
          "",
        currency: Currency.USD || Currency.CAD,
      };
      props.buyLoadRequest({
        query: modelLoad.getRequestPayload(),
        data,
      });
      setScreenName("screen_book_load");

      LPEFeedbackWrapper.log(EVENT.UE_LOAD_RATE_ACCEPT, {
        screen: SCREEN.LOAD_DETAILS_RATE,
        lead: lead(),
        loadId: [selectedLoadId],
        rank: load[0].rank,
        resultId: props.resultId
      });

      logEvent(EVENT.UE_LOAD_RATE_ACCEPT, {
        screen: SCREEN.LOAD_DETAILS_RATE,
        carrierId:userDetails && userDetails.memberDetailsResponse &&
        userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
        lead: lead(),
        loadId: selectedLoadId,
        rank: load[0].rank,
        resultId: props.resultId
      });
    } else {
      props.showAlert({
        isShowAlert: true,
        alertMessage: PLEASE_CHECK_NETWORK_CONNECTIVITY_MESSAGE,
        alertTitle: NO_NETWORK,
      });
    }
    setBookLoadModal(false);
  };

  const declineBookLoad = () => {
    setBookLoadModal(false);
    logEvent(EVENT.UE_LOAD_RATE_DENY, {
      screen: SCREEN.LOAD_DETAILS_RATE,
      carrierId:userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
      lead: lead(),
    });
  };

  const buyLoadModal = (
    loadId: string,
    detail: any,
    sourceSystem: string,
    loads = [],
    isSimilarLoad = false,
    isAssigned?:any
  ) => {
    setSelectedLoadId(loadId);
    setIsSimilarLoad(isSimilarLoad);
    setSimilarLoads(loads);
    if (detail.rate && detail.rate.totalCharge && detail.buyAllowed) {
      if(updateduserDetails?.memberDetailsResponse?.carrierInfo?.carrierActiveIndicator === true){
        var message = "";
        var modalType = "";
        if(sameDateFreightCheckValue(detail?.load?.loadStop) && appointmentState(detail?.load?.loadStop,props) === APPOINTMENT_INDICATOR_STATE_VALUE)
        {
          message = IONICWrapper?.details?.keys?.configuration?.GenericPreBookNowPopUpMessage || GENERIC_PRE_BOOK_NOW_POPUP_MESSAGE;
          modalType = `${SAME_DAY_PICKUP_MODAL_TYPE +"," +APPOINTMENT_MODAL_TYPE}`;
        }
        else if(sameDateFreightCheckValue(detail?.load?.loadStop))
        {
          message = IONICWrapper?.details?.keys?.configuration?.SamedayPickupPopupMessage || SAME_DAY_PICKUP_POPUP_MESSAGE;
          modalType = SAME_DAY_PICKUP_MODAL_TYPE;
        }
        else if(appointmentState(detail?.load?.loadStop,props) === APPOINTMENT_INDICATOR_STATE_VALUE)
        {
          message = IONICWrapper?.details?.keys?.configuration?.AppointmentModalMessage || APPOINTMENT_MODAL_MESSAGE ;
          modalType = APPOINTMENT_MODAL_TYPE;
        }
        if(message!== "")
        {
           setPreBookNowModalOpen(true)
           setPreBookNowModalMessage(message)
           setPreBookNowModalType(modalType)
           setLoadForModal(detail)
           logEvent(EVENT.SV_PRE_BOOK_NOW_MODAL, {
            screen:SCREEN.PRE_BOOK_NOW_MODAL,
            loadId: [loadId],
            sessionId :sessionId,
            lead: lead(),
            modalType: modalType
          });  
        }
       else {
         setBookLoadModal(true);

      LPEFeedbackWrapper.log(EVENT.UE_BOOK_LOAD_NOW, {
        screen: SCREEN.LOAD_DETAILS_RATE,
        lead: lead(),
        loadId: [loadId],
        rank: detail.load.rank,
        resultId: detail.resultId
      });

      logEvent(EVENT.SV_LOAD_DETAILS_RATE, {
        screen: SCREEN.LOAD_DETAILS_RATE,
        lead: lead(),
        loadId: loadId,
        rank: detail.load.rank,
        resultId: detail.resultId
      });
       }
    }
    else if(!props?.module.includes("MyLoad"))
    {
     setGetQualifiedModal(true)
    }
    } else {
      if(updateduserDetails?.memberDetailsResponse?.carrierInfo?.carrierActiveIndicator === false && 
        updateduserDetails?.memberDetailsResponse?.carrierInfo?.source !== "ASL" &&
        !props?.module.includes("MyLoad")
        ) {
        setGetQualifiedModal(true)
      }
     else{
      const storeData = store.getState();
      const session = storeData && storeData.App && storeData.App.session;
      const sessionId = getSessionId(session.uuid);
      const loadshipmentId = shipmentDetails
                            && shipmentDetails.shipments
                            && shipmentDetails.shipments.length > 0 
                            ? shipmentDetails.shipments[0].shipmentId : [];
      props?.module.includes("MyLoad") && 
      logEvent(getContactEventDetails(props?.module).eventName, {
        screen: getContactEventDetails(props?.module).screenName,
        loadId: loadshipmentId,
        lead: getContactEventDetails(props?.module).screenName,
        sessionId :sessionId
      });
      const callback = (responseType: string, data: any) => {
      if (responseType === "success") {
        setContactUsModal(true);
        setContactDetails(data?.message)
      } else {
       ToastMessage.showWeb(CONTACT_DETAILS_NOT_FOUND);
     }
     };
     const payload = loadId;
     dispatch(contactUsDetailsRequest({
       query: payload,
       callback
     }))
     setSys(sourceSystem);
     }
    }
    logEvent(
      detail ? 
      (detail.rate && detail.rate.totalCharge
        ? EVENT.UE_BOOK_LOAD_NOW
        : detail.rate && detail.rate.totalCharge === ""
          ? EVENT.UE_VIEW_LOAD_CALL_US
          : EVENT.UE_CONTACT_TO_BOOK)
          :(isAssigned ? EVENT.UE_LOAD_VIEW_CALL : EVENT.UE_VIEW_LOAD_CALL_US ) ,
      {
        screen: SCREEN.LOAD_DETAILS,
        loadId,
        carrierId: userDetails && userDetails.memberDetailsResponse &&
        userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
        lead: lead(),
      }
    );
  };

  const getRateDetails = () => {
    const loads = isSimilarLoad ? similarLoads : props.loads;
    details = loads.filter((item: any) => item.loadId === selectedLoadId);
    return details[0].rate;
  };
  const getLoadIsManaged = () => {
    const loads = isSimilarLoad ? similarLoads : props.loads;
    details = loads.filter((item: any) => item.loadId === selectedLoadId);
    return details[0].managedEquipment || false;
  };


  const removeLoadsFromStore = (loadId: string) => {
    if(loadId){
      props.handlerAfterBookLoad && props.handlerAfterBookLoad();
      props.removeRecommendedResults && props.removeRecommendedResults({ loadId });
      props.removewatchedResults && props.removewatchedResults({ loadId });
    }
  };

  const getShipmentBookLoad = async (shipmentId: any) => {
    const __getShipmentmodel: GetShipment = new GetShipment();
    __getShipmentmodel.shipmentIds = shipmentId;
    props.buyLoadShipmentRequest(
      {
        query: __getShipmentmodel.getRequestShipmentPayload(),
        shipmentId,
        module: "",
        isPullToRefresh: false,
      },
      (res : any) => {
        const _shipmentData = res?.getShipment?.length > 0 && res?.getShipment[0];
        if(_shipmentData){
        setBookLoad(true);
        }
        else
        {
          ToastMessage.showWeb(res?.errors && res?.errors[0].message)
        }
      }
    );
  };
  const LO3PostBuyLoadProcess = async (shipmentId: any) => {
    const __getShipmentmodel: GetShipment = new GetShipment();
    __getShipmentmodel.shipmentIds = shipmentId;
    props.buyLoadShipmentRequest(
      {
        query: __getShipmentmodel.getRequestShipmentPayload(),
        shipmentId,
        module: "",
        isPullToRefresh: false,
      },
      (res:any) => {
        const _shipmentData = res?.getShipment?.length > 0 && res?.getShipment[0];
        if(_shipmentData){
        setShipmentData(_shipmentData)
        const DriverData = {...userDetails?.memberDetailsResponse?.member,userPrincipalName:userDetails?.memberDetailsResponse?.member?.upn}
        setDriverDetails(DriverData);
        const payload = getPredecessorShipmentPayload({loadDetails: _shipmentData,driver: DriverData})
        const predecessorCallback = (response:any)=>{
          setShowDriverAssignment(true);
          if(response?.data?.predecessorShipmentId) setPredecessorShipment(response?.data?.predecessorShipmentId);
        }
        dispatch(getPredecessorShipment(payload,predecessorCallback));
      }
  else
  {
    ToastMessage.showWeb(res?.errors && res?.errors[0].message)
    
  }} 
    );
  };

  const confirmBookLoad = () => {
    const loads = isSimilarLoad ? similarLoads : props.loads;
    const load = loads.filter(
      (item: any) => item.loadId === selectedLoadId
    );
    if (props.isNetworkAvailable) {
      if (props.bookLoadStatus.status === BOOKLOAD_STATUS_OK) {
        
    if(isElevatedLeasedOwenerOprRole()){
      props?.bookLoadStatus?.message && setConfirmBookLoadHeader(props?.bookLoadStatus?.message?.split("  ").slice(1).join("\n "))
        LO3PostBuyLoadProcess(selectedLoadId)
    }else {
      const shipmentId = selectedLoadId;
      const shipmentIds: any = [];
      shipmentIds.push(shipmentId);
      const getShipmentmodel: GetShipment = new GetShipment();
      getShipmentmodel.shipmentIds = shipmentIds;
      getShipmentBookLoad(shipmentId);
      props.buyLoadStatusRemove();
    }
        logEvent(EVENT.UE_BOOK_SUCCESS, {
          screen: SCREEN.LOAD_DETAILS_RATE,
          loadId: load[0].loadId,
          carrierId: userDetails && userDetails.memberDetailsResponse &&
          userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
          lead: lead(),
        });
      }
      if (
        props.bookLoadStatus.status === BOOKLOAD_ONHOLD ||
        BOOKLOAD_STATUS_REJECTED
      ) {
        logEvent(EVENT.UE_BOOK_FAILED, {
          screen: SCREEN.LOAD_DETAILS_RATE,
          loadId: load[0]?.loadId,
          carrierId: userDetails && userDetails.memberDetailsResponse &&
          userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
          lead: lead(),
        });
        ToastMessage.showWeb(props.bookLoadStatus.message)
      props.buyLoadStatusRemove();
      }
      if (props.bookLoadStatus.status === BOOKLOAD_CANCELLED) {
        removeLoadsFromStore(selectedLoadId || null);
        ToastMessage.showWeb(props.bookLoadStatus.message)
        props.buyLoadStatusRemove();
      }
      if (props.bookLoadStatus.status === BOOKLOAD_TIMEOUT) {
        ToastMessage.showWeb(props.bookLoadStatus.message)
       props.buyLoadStatusRemove();
      }
    } else {
      props.showAlert({
        isShowAlert: true,
        alertMessage: PLEASE_CHECK_NETWORK_CONNECTIVITY_MESSAGE,
        alertTitle: NO_NETWORK,
      });
    }
  };
  const getSelectedLoadsCapacityType = (selectedLoad: IEShipment[], loads: IEShipment[]) => {
    if (Array.isArray(selectedLoad)) {
      if (selectedLoad?.length > 0) {
        let data: IEShipment[] = loads?.filter((obj: IEShipment) => (obj.shipmentId === selectedLoad[0].shipmentId))
        return data?.length > 0 ? [{ ...data[0], ...selectedLoad[0] }] : selectedLoad;
      }
    } else if (!isEmptyObject(selectedLoad)) {
      return selectedLoad;
    } else {
      return loads;
    }
  } 

  const getSpecificLoadDetails = (selectedLoad: any) => {
    const specificLoad = props.history.location.state.showReferences ?
      loads.find(
        (obj: any) => obj.shipmentId === selectedLoad.shipmentId
      )
      : getSelectedLoadsCapacityType(selectedLoad,loads)
    return specificLoad || selectedLoad
  }

  const openReLoadModal = () => {
    setSuccessorModal(true);
  }

  const negativeReloadClick = (reloadtype : string) => {
    setSuccessorModal(false)
    const
      _intentPayload: CarrierIntentMessageProps = {
        sourceSystem: assignedDriverResponse.assignDriverToShipment.shipment.sourceTMS,
        shipmentID: assignedDriverResponse.assignDriverToShipment.shipment.shipmentId,
        commonCarrierID: isElevatedLeasedOwenerOprRole() ? driverDetails?.carrierId :  assignedDriverResponse.assignDriverToShipment.shipment.assignedCarrierId,
        carrierReloadIntent: reloadtype === "No Reload"? NO_NEXT_ROUTE :NEED_NEXT_ROUTE,
        dispatcherName: props.userDetails && props.userDetails.memberDetailsResponse &&
        props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.firstName + " " + props.userDetails && props.userDetails.memberDetailsResponse &&
        props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.lastName,
        eventDateAndTime: new Date().toISOString(),
      }
    dispatch(publishCarrierIntentMessage({ intentPayload: _intentPayload, reload: false, loadPostingData: {} }));
    props.history.push(`/app/${isElevatedLeasedOwenerOprRole()?MODULES.DRIVER_ASSIGNED_MODULE : MODULES.CARRIER_ASSIGNED_MODULE}`)
    dispatch(clearSuccessorShipmentResponse())
  }

  const positiveReloadClick = () => {
    setSuccessorModal(false)

    const _intentPayload: CarrierIntentMessageProps = {
      sourceSystem: assignedDriverResponse.assignDriverToShipment.shipment.sourceTMS,
      shipmentID: assignedDriverResponse.assignDriverToShipment.shipment.shipmentId,
      commonCarrierID: isElevatedLeasedOwenerOprRole() ? driverDetails?.carrierId : assignedDriverResponse.assignDriverToShipment.shipment.assignedCarrierId,
      carrierReloadIntent: NEED_NEXT_ROUTE,
      dispatcherName: props.userDetails && props.userDetails.memberDetailsResponse &&
      props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.firstName + " " + props.userDetails && props.userDetails.memberDetailsResponse &&
      props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.lastName,
      eventDateAndTime: new Date().toISOString(),
    }
    const searchData = getReloadShipmentDetails(assignedDriverResponse, props.userDetails, offSetValues)
    const searchParams = constructSearchParams(assignedDriverResponse, offSetValues)

    dispatch(publishCarrierIntentMessage({
      intentPayload: _intentPayload,
      loadPostingData: searchData,
      reload: true,
    }))
    props.history.push("/app/search", {
      params: searchParams,
      searchInput: searchParams,
      totalRecords: 0,
      isRecent: false,
      isReloadButton: true,
    })
    dispatch(clearSuccessorShipmentResponse())
  }
  const footerData = () => {
    const onClickFooterLink = ()=>
    {
      LPEFeedbackWrapper.log(EVENT.UE_NO_NEXT_ROUTE, {
        screen: SCREEN.RELOAD_DRIVER,
        carrierId: userDetails && userDetails.memberDetailsResponse &&
        userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
        shipmentId: assignedDriverResponse.assignDriverToShipment.shipment.shipmentId,
      });
     logEvent(EVENT.UE_NO_NEXT_ROUTE, {
      screen: SCREEN.RELOAD_DRIVER,
      carrierId: userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
      shipmentId:assignedDriverResponse.assignDriverToShipment.shipment.shipmentId,
    });
    negativeReloadClick("No Reload")
    }
    return (
      <span>
        If no reload needed <span className="footerlink" onClick={onClickFooterLink}>click here</span>
      </span>
    );
  };
  const reloadModalProps = {
    isModalOpen: hasSuccessorModal,
    title:  "Reload Driver",
    footer: footerData,
    contentAlignment: "left",
    size: "small_height_reload",
    message:  
      reloadPopupMessage
        .replace('destinationCity', getDestinationCityState(assignedDriverResponse).city)
        .replace("state", getDestinationCityState(assignedDriverResponse).state),
    
    contentScroll: "deny",
    buttons: [
      {
        title: "Reload Later",
        type: "secondary-cta-btn-web",
        onClick: () => {
          LPEFeedbackWrapper.log(EVENT.UE_NEED_NEXT_ROUTE_LATER, {
            screen: SCREEN.RELOAD_DRIVER,
            carrierId: userDetails && userDetails.memberDetailsResponse &&
            userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
            shipmentId:assignedDriverResponse.assignDriverToShipment.shipment.shipmentId,
          });
          
          logEvent(EVENT.UE_NEED_NEXT_ROUTE_LATER, {
            screen: SCREEN.RELOAD_DRIVER,
            carrierId: userDetails && userDetails.memberDetailsResponse &&
            userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
            shipmentId:assignedDriverResponse.assignDriverToShipment.shipment.shipmentId,
          });
          negativeReloadClick("Reload Later");
        }
      },
      {
        title: "Reload Now",
        type: "primary-cta-btn-web",
        onClick: () => {
          LPEFeedbackWrapper.log(EVENT.UE_NEED_NEXT_ROUTE, {
            screen: SCREEN.RELOAD_DRIVER,
            carrierId: userDetails && userDetails.memberDetailsResponse &&
            userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
            shipmentId:assignedDriverResponse.assignDriverToShipment.shipment.shipmentId,
          });

          logEvent(EVENT.UE_NEED_NEXT_ROUTE, {
            screen: SCREEN.RELOAD_DRIVER,
            carrierId: userDetails && userDetails.memberDetailsResponse &&
            userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
            shipmentId: assignedDriverResponse.assignDriverToShipment.shipment.shipmentId,
          });
          positiveReloadClick();
        }
      }
    ]
  };
 
  const preBookNowModalProps = {
      isModalOpen:  preBookNowModalOpen,
      title: IONICWrapper?.details?.keys?.configuration?.GenericPreBookNowPopUpTitle || GENERIC_PRE_BOOK_NOW_POPUP_TITLE,
      message : preBookNowModalMessage,
      aditionalCssClass : "",
      size: (sameDateFreightCheckValue(loadForModal?.load?.loadStop) && appointmentState(loadForModal?.load?.loadStop,props) === APPOINTMENT_INDICATOR_STATE_VALUE )?"pre_booknow" :"medium_booknow",
      contentScroll: "deny",
      backdropDismiss:false,
      buttons: [
        {
          title: 'Cancel',
          type: "secondary-cta-btn-web",
          onClick: () => {
            setPreBookNowModalOpen(false)
            logEvent(EVENT.UE_PRE_BOOK_NOW_CANCELLATION, {
              screen:SCREEN.SAMEDAY_PICKUP_MODAL,
              loadId: selectedLoadId,
              sessionId :sessionId,
              lead: lead(),
              modalType: preBookNowModalType
            }); 
         }
        },
        {
          title: IONICWrapper?.details?.keys?.configuration?.AppointmentModalButtonName || APPOINTMENT_MODAL_BUTTON_NAME,
          type: "primary-cta-btn-web",
          onClick: () => {
            setPreBookNowModalOpen(false)
              setBookLoadModal(true)
              logEvent(EVENT.UE_PRE_BOOK_NOW_ACCEPTANCE, {
                screen:SCREEN.SAMEDAY_PICKUP_MODAL,
                loadId: selectedLoadId,
                sessionId :sessionId,
                lead: lead(),
                modalType: preBookNowModalType
              }); 
              LPEFeedbackWrapper.log(EVENT.UE_BOOK_LOAD_NOW, {
                screen: SCREEN.LOAD_DETAILS_RATE,
                lead: lead(),
                loadId: selectedLoadId,
                rank: loadForModal?.load?.rank,
                resultId: loadForModal?.resultId
              });
        
              logEvent(EVENT.SV_LOAD_DETAILS_RATE, {
                screen: SCREEN.LOAD_DETAILS_RATE,
                lead: lead(),
                loadId: selectedLoadId,
                rank: loadForModal?.load?.rank,
                resultId: loadForModal?.resultId
              });

         }
        }
      ]
    };
  
  return (
    <>
      <CustomModalWeb {...preBookNowModalProps}/>    
      <IonList
        className={`sni-loads-list ${className}`}
        data-testid="watched-tile"
      >
        {props.history &&
          props.history.location &&
          props.history.location.state &&
          props.history.location.state.shipments &&
          props.history.location.state.shipments.length > 0 ? (
            props.history.location.state.shipments.map(
              (load: any, index: number) => (
                <div className={`searched-shipment ${load?.exclusiveLoad ? "exclusiveLoad" : ""}`} key={index}>
                  {load?.exclusiveLoad && <img className="exclusive" alt="Exclusive" src="assets/images/exclusive.svg" />}
                  <LoadTile
                    key={index}
                    {...props}
                    {...load}
                    load={getSpecificLoadDetails(load)}
                    openReLoadModal={openReLoadModal}
                    module={module}
                    showMap={showMapId === index}
                    setShowMap={(status: boolean) =>
                      setShowMapId(status ? index : "")
                    }
                    buyLoadModal={buyLoadModal}
                    userDetails={userDetails}
                    loadData={props.loadData}
                    rowIndex={index + 1}
                    onChangeRowIndex={props.onChangeRowIndex}
                    toCallExpand={
                      (props.shipmentToExpand &&
                        (props.shipmentToExpand.loadId ||
                          props.shipmentToExpand.shipmentId) ==
                        (load.shipmentId || load.loadId)) ||
                      false
                    }
                    onScreen={isOnScreen}
                    searchByReferenceIdManageUser={props.searchByReferenceIdManageUser}
                    fetchShipmentsManageUser={props.fetchShipmentsManageUser}
                  />
                </div>
              )
            )
          ) : loads && lead() === TAB.RECOMMENDED ? (
            <RecommendedList
              {...props}
              loads={loads}
              module={module}
              buyLoadModal={buyLoadModal}
              userDetails={userDetails}
              showMapId={showMapId}
              setShowMapId={setShowMapId}
              onScreen={isOnScreen}
            />
          ) : (
              loads?.map((load: any, index: number) => (
                <div className={`searched-shipment ${load?.exclusiveLoad ? "exclusiveLoad" : ""}`} key={index}>
                  {load?.exclusiveLoad && <img className="exclusive" alt="Exclusive" src="/carrier/assets/images/exclusive.svg" />}
                  <LoadTile
                    openReLoadModal={openReLoadModal}
                    {...props}
                    {...load}
                    load={load}
                    module={module}
                    showMap={
                      props.topRecommLoadClick
                        ? props.topRecommLoadClick === load.loadId
                        : showMapId === index
                    }
                    setShowMap={(status: boolean) =>
                      setShowMapId(status ? index : "")
                    }
                    buyLoadModal={buyLoadModal}
                    userDetails={userDetails}
                    loadData={props.loadData}
                    isCarrierLoad={props.isCarrierLoad}
                    rowIndex={index + 1}
                    onChangeRowIndex={props.onChangeRowIndex}
                    toCallExpand={
                      (props.shipmentToExpand &&
                        (props.shipmentToExpand.loadId ||
                          props.shipmentToExpand.shipmentId) ==
                        (load.shipmentId || load.loadId)) ||
                      false
                    }
                    fetchAvailableLoads={props.fetchAvailableLoads}
                    onScreen={isOnScreen}
                    clearTopRecommedLoadDetails={props.clearTopRecommedLoadDetails}
                  />
                  {(props?.isManageUserAssignedLoad && load?.isGapForDriver && index !== props?.loads?.length - 1) && <IonCardContent className="my-driver-action-card-content">
                    <IonRow className="my-driver-action-row" >
                      {driverGapFillInActions.map((action: any) => {
                        return <div className="my-driver-action-click" onClick={() => {
                          push(`${action.path}`)
                          logEvent(`ue_${action.slug}`, {
                            screen: SCREEN.MANAGE_USERS,
                            sessionId: sessionId,
                            lead: lead(),
                          });
                        }}>
                          <IonIcon className="my-driver-action-icon" src={`assets/icon/${action.icon}`} />

                          <IonLabel className="my-driver-action-label">{action.label}</IonLabel>
                        </div>
                      })}
                    </IonRow>
                  </IonCardContent>}
                </div>
              ))
            )}
      </IonList>
      {isBookLoadModal ? (
        <BookLoadModal
          isBookLoadModal={isBookLoadModal}
          bookedDetails={getRateDetails()}
          buyLoad={buyLoad}
          declineBookLoad={declineBookLoad}
          carrierId={{}}
          lead="true"
          loadId={selectedLoadId}
          isManaged={getLoadIsManaged()}
        />
      ) : getQualifiedModal ? (
        <GetQualifiedModal
          isOpen={getQualifiedModal}
          onClosed={() => setGetQualifiedModal(false)}
        />
      ) : contactUsModal ? (
        <ContactUsModal
          isOpen={contactUsModal}
          onClosed={() => setContactUsModal(false)}
          contactDetails={contactDetails}
        />
      ) : null}
      {showDriverAssignment && isElevatedLeasedOwenerOprRole() ? (
        <ConfirmDriverDialog
          userDetails={props.userDetails}
          driverDetails={driverDetails}
          open={showDriverAssignment}
          onDismiss={(cancle: boolean) => {
            setShowDriverAssignment(false);
          }}
          loadDetails={{ ...props, ...shipmentData }}
          loadData={props.loadData}
          calculateTime={calculateTime}
          count={null}
          module={""}
          predecessorShipmentDetails={predecessorShipment}
          isLo3User={isElevatedLeasedOwenerOprRole()}
          header={confirmBookLoadHeader}
          handleReloadPopup={() => {
            setShowDriverAssignment(false);
            (props.successorShipment === null ||
              (props.successorShipment &&
                props.successorShipment.shipmentId === null)) &&
              setSuccessorModal(true);
            props.buyLoadStatusRemove();
          }}
        />
      ) : props.bookLoadStatus &&
        props.bookLoadStatus?.status &&
        !props.topRecommLoadClick &&
        props.bookLoadStatus.message ? (
        <BookLoadConfirmModal
          confirmModal={!!props.bookLoadStatus?.status}
          bookLoadResponse={props.bookLoadStatus}
          confirmBookLoad={confirmBookLoad}
          loadId={selectedLoadId}
          updateClickType={updateClickType}
        />
      ) : null}
      {hasSuccessorModal ? <CustomModalWeb {...reloadModalProps} /> : null}
    </>
  );
};


const RecommendedList = React.memo((props: any) => {
  const { loads, buyLoadModal, userDetails, showMapId, setShowMapId, module } = props;
  const [showSimilarLoadId, setShowSimilarLoadId] = useState<any>("");
  return (
    loads.map((load: any, index: number) => (
      <div className={`recmd-shipment ${load?.exclusiveLoad ? "exclusiveLoad": ""}`} key={index}>
        {load?.exclusiveLoad && <img className="exclusive" alt="Exclusive" src="/carrier/assets/images/exclusive.svg" />}
        <LoadTile
          key={index}
          {...props}
          {...load}
          load={load}
          module={module}
          showMap={props.topRecommLoadClick? props.topRecommLoadClick === load.loadId  : (showMapId === index)}
          setShowMap={(status: boolean) =>{
            setShowMapId(status ? index : "")}
          }
          buyLoadModal={buyLoadModal}
          userDetails={userDetails}
          loadData={props.loadData}
          isCarrierLoad={props.isCarrierLoad}
          rowIndex={index + 1}
          onChangeRowIndex={props.onChangeRowIndex}
          toCallExpand={
            (props.shipmentToExpand &&
              (props.shipmentToExpand.loadId ||
                props.shipmentToExpand.shipmentId) ==
              (load.shipmentId || load.loadId)) ||
            false
          }
          fetchAvailableLoads={props.fetchAvailableLoads}
          onScreen={(loadId:string, rank: string)=>props.onScreen(loadId, rank)}
          clearTopRecommedLoadDetails={props.clearTopRecommedLoadDetails}
          recommended={true}
        />
        {load.similarLoads && load.similarLoads.length>0 &&
          <LoadSimilarContainer
            {...props}
            loads={load.similarLoads}
            primaryLoad={load.loadId}
            rank={load.rank}
            module={TAB.RECOMMENDED}
            showMapId={showMapId}
            showSimilarLoadId={showSimilarLoadId}
            setShowSimilarLoadId={(value: any) => setShowSimilarLoadId(value)}
            openMap={(status: boolean, index: any) => { setShowMapId(status ? index : "") }}
            buyLoadModal={(loadId: string,
              detail: any,
              sourceSystem: string
             ) => buyLoadModal(loadId,
                detail,
                sourceSystem,
                load.similarLoads,
                true)}
            userDetails={userDetails}
            fetchSimilarLoads={props.fetchSimilarLoads}
            fetchAvailableLoads={props.fetchAvailableLoads}
            onScreen={(loadId:string, rank: string)=>props.onScreen(loadId, rank)}
            recommended={true}
          />}
      </div>
    ))
  );
});

export default LoadsList;
